import React from 'react';
import { Navigate, useLocation } from 'react-router';
import { rememberReturnTo } from '../../../features/auth/returnTo';

/**
 * Sends a signed-out visitor to sign in, remembering the page they asked for (with its
 * query and hash) so they land on it afterwards. Every notification email links into the
 * app; before this, only /verify did, and everything else opened on the dashboard (QA
 * sweep M-15). returnTo only ever follows a same-site relative path.
 */
export default function SignInFirst() {
  const { pathname, search, hash } = useLocation();
  rememberReturnTo(`${pathname}${search}${hash}`);
  return <Navigate to="/login" replace />;
}
